import React from 'react'
import { Dropdown, Avatar, Space } from 'antd'
import { LogoutOutlined, ReloadOutlined, UserOutlined, DownOutlined } from '@ant-design/icons'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../../../redux/slice/auth'

const ProfileMenu = () => {
  const dispatch = useDispatch()
  const user_profile_picture = useSelector(s => s._auth.ca_profile_picture)
  const user_name = useSelector(s => s._auth.ca_name)
  const user_roles = useSelector(s => s._auth.ca_roles)
  const navigate = useNavigate()

  const handleLogout = () => {
    dispatch(logout())
  }

  const items = [
    {
      key: 'greet',
      label: (
        <>
          <div>
            <FormattedMessage id="topBar.profileMenu.hello" />, <strong>{user_name}</strong>
          </div>

          <div>
            <strong>
              <FormattedMessage id="topBar.profileMenu.role" />:{' '}
            </strong>
            {user_roles.join(', ')}
          </div>
        </>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'reload',
      label: (
        <span onClick={() => navigate(0)}>
          <ReloadOutlined style={{ marginRight: '0.5rem' }} />
          <FormattedMessage id="topBar.profileMenu.refresh" />
        </span>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: (
        <span onClick={handleLogout}>
          <LogoutOutlined style={{ marginRight: '0.5rem' }} />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </span>
      ),
    },
  ]

  return (
    <Dropdown menu={{ items, selectable: false }} trigger={['click']}>
      <Space
        style={{
          marginRight: '.5rem',
        }}
      >
        <Avatar shape="square" size="large" src={user_profile_picture} icon={<UserOutlined style={{ color: 'grey' }} />} />
        <DownOutlined />
      </Space>
    </Dropdown>
  )
}

export default ProfileMenu
